<ng-container *ngIf="saving">
    <div class="sidebar">
        <app-loading aria-live="polite" aria-label="Loading dialog"></app-loading>
    </div>
</ng-container>

<div class="sidebar" *ngIf="passengerInfo">
    <app-sidebar-header title="{{ passengerName | uppercase }}" [confirmation]="showSave">
        <div custom-label *ngIf="_hasFrequentFlyer">
            <app-svg classes="logo__booking-loyalty-program {{ logoClasses }}" alt="{{ ('bookingDetails.alt.milesGo' | ibeadmin:'sync') + ' ' + (passengerInfo.tierLevelFF) + ' ' + ('bookingDetails.alt.logo' | ibeadmin:'sync') }}" svg="sprite.svg#{{ loyaltyLogo }}"
                aria-hidden="true">
            </app-svg>
        </div>
        <!-- <div actions *ngIf="!isCorporate && userData != null && isAward">
            <button class="button button--small" (click)="INDRA_clearBeneficiaryFields()" [disabled]="saving">
				{{'bookingDetails.text.reset' | ibeadmin:'sync'}}
			</button> &nbsp;&nbsp;
        </div> -->
        <div actions *ngIf="showSave">
            <button class="button button--small" (click)="saveSidebar()" [disabled]="saving">
				{{'bookingDetails.text.save' | ibeadmin:'sync'}}
			</button>
        </div>
    </app-sidebar-header>
    <ng-container *ngIf="notif.show">
        <app-notification [classes]="'top-gap'" [style]="notif.style" [title]="notif.title">
            <div message *ngFor="let message of notif.message">
                <span *ngIf="message === 'Incorrect FF number'"> {{'bookingDetails.errorMessage.incorrectFFNumber' | ibeadmin:'sync'}} </span>
                <span *ngIf="message === 'The name does not correspond to the FF number'"> {{'bookingDetails.errorMessage.nameAndFFMismatch' | ibeadmin:'sync'}} </span>
                <span *ngIf="message === 'Invalid docNum'"> {{'bookingDetails.error.personalDocDocumentNumPattern' | ibeadmin:'sync'}} </span>
                <span *ngIf="message !== 'Incorrect FF number' && message !== 'The name does not correspond to the FF number' && message !== 'Invalid docNum'"> {{ message | ibeadmin:'sync'}} </span>
                <!--<span *ngIf="message === 'Name matches'"> {{ 'bookingDetails.errorMessage.sameNameError' | ibeadmin:'sync'}} </span>-->
            </div>
            <!--
			<div actions>
				<button class="button" (click)="hideNotifications()">
					{{'bookingDetails.button.close' | ibeadmin:'sync'}}
				</button>
			</div>
			-->
        </app-notification>
    </ng-container>
    <div *ngIf="!isCorporate && userData != null && isAward">
        <div class="card-wrapper" *ngIf="!notif.show && !errorMessage && userInfo$ | async as user">
            <h4>{{'bookingDetails.text.hello' | ibeadmin:'sync'}}, {{ INDRA_printLoggedInName(user) }}</h4>
            <p class="text-margin-top">{{'bookingDetails.text.duringCivilYearCanAdd' | ibeadmin:'sync'}} <span class="display-inline-span">{{CAP_BENEFICIARIES_NUMBER}} {{'bookingDetails.text.guestPassengers' | ibeadmin:'sync'}} </span>{{'bookingDetails.text.toYourList' | ibeadmin:'sync'}}
                <span *ngIf="numberOfBeneficiaries < CAP_BENEFICIARIES_NUMBER && numberOfBeneficiaries > 0">,<span class="display-inline-span"> {{'bookingDetails.text.youAlreadyHave' | ibeadmin:'sync'}} {{ numberOfBeneficiaries }}</span>{{textEnd}} {{'bookingDetails.text.choosePassengerFromList'
                | ibeadmin:'sync'}}</span><span *ngIf="numberOfBeneficiaries == 0"><span class="display-inline-span">{{textEnd}} {{'bookingDetails.text.listEmpty' | ibeadmin:'sync'}}</span>, {{'bookingDetails.text.fillFields' | ibeadmin:'sync'}}{{textEnd}}</span>
                <span *ngIf="numberOfBeneficiaries >= CAP_BENEFICIARIES_NUMBER">{{textEnd}}<span class="display-inline-span"> {{'bookingDetails.text.listFull' | ibeadmin:'sync'}}</span>, {{'bookingDetails.text.onlyChooseFromList' | ibeadmin:'sync'}}{{textEnd}}</span>
            </p>
            <p class="text-margin-btm"><span class="display-inline-span">{{listBoldStatusText}}</span>{{listStatusText}}</p>
            <div class="form-field--row grid no-padding">
                <div class="form-field col-12 col-tp-12 col-p-12">
                    <label class="label" for="user_employee">{{'bookingDetails.text.passenger' | ibeadmin:'sync'}}</label>
                    <app-select-beneficiary [id]="'user_employee'" [placeholder]="('bookingDetails.text.choosePassenger' | ibeadmin:'sync')" (change)="INDRA_updateBeneficiaryData($event)" [inputOptions]="beneficiaryNames" [(ngModel)]="beneficiarySelected" [isReset]="isReset"
                        (onReset)="INDRA_onReset($event)">
                    </app-select-beneficiary>
                </div>
            </div>
        </div>
    </div>
    <div class="sidebar__body sl--scrollable" id="sidebar__body" #sidebar__body>
        <div class="card-wrapper" *ngIf="!isAward && !notif.show && !errorMessage && userInfo$ | async as user">
            <div *ngIf="!isCorporate">
                <h4>
                    {{'bookingDetails.text.hello' | ibeadmin:'sync'}} {{ INDRA_printLoggedInName(user) }}
                </h4>
                <div>
                    <span>
                        {{'bookingDetails.text.fillByAccountDetails' | ibeadmin:'sync'}}
                    </span>
                </div>

                <button [attr.aria-label]="'Import ' + INDRA_printLoggedInName(user) + ' data to fill the form'" class="button top-gap full-width-mobile display--block" (click)="INDRA_importUserData('userData')">
                    {{'bookingDetails.button.fillPaxDetails' | ibeadmin:'sync'}}
                </button>
            </div>
            <!--note: from post-sprint 8 client code merge
            <div *ngIf="isCorporate">
                <h4>Hello,</h4>
                <span>Is a company's employee travelling? <br>Choose an employee to import her details.</span>
                <div class="form-field--row grid no-padding">
                    <div class="form-field col-12 col-tp-12 col-p-12">
                        <label class="label" for="user_employee">Employee</label>
                        <app-select-input [id]="'user_employee'" [placeholder]="'Choose company employee'" (change)="TAP_importUserData()" [inputOptions]="employees" [(ngModel)]="userEmployee">
                        </app-select-input>
                    </div>
                </div>
            </div>-->
        </div>

        <div class="card-wrapper" *ngIf="hasCookies && !userInfo && dataFromCookie && !notif.show && !errorMessage">
            <h4>{{'bookingDetails.text.passengerDetailsImported' | ibeadmin:'sync'}}</h4>
            <p>
                {{'bookingDetails.text.resetForm1' | ibeadmin:'sync'}}
                <a [attr.aria-label]="'Reset this form'" (click)="INDRA_handleReset()" class="link">
					{{'bookingDetails.text.resetForm2' | ibeadmin:'sync'}} 
				</a> {{'bookingDetails.text.or' | ibeadmin:'sync'}}
                <a [attr.aria-label]="'Delete all passenger and contact details'" (click)="INDRA_handleDeleteCookies()" class="link">
					{{'bookingDetails.text.deletePaxCookies' | ibeadmin:'sync'}}
				</a>
            </p>
        </div>

        <app-passenger-detail-main-info #mainInfo [error]="errorMessage" [displayValidationMessages]="displayValidationMessages" [departureDate]="departureDate" [showAdditionalFields]="!requireAPISection">
        </app-passenger-detail-main-info>

        <app-passenger-detail-personal-documents *ngIf="requireAPISection" #personalDocs [hasImportedData]="hasImportedData" [displayValidationMessages]="displayValidationMessages" [departureDate]="departureDate" [isUKDestination]="isUKDestination">
        </app-passenger-detail-personal-documents>

        <app-passenger-detail-emergency-contact #emergencyContact *ngIf="notInfant && isBrazilOrigin" [displayValidationMessages]="displayValidationMessages">
        </app-passenger-detail-emergency-contact>

        <app-passenger-detail-student #studentInfo *ngIf="notInfant && studentDiscountSelected" [displayValidationMessages]="displayValidationMessages">
        </app-passenger-detail-student>

        <app-passenger-detail-resident #residentInfo *ngIf="notInfant && residentDiscountSelected" [displayValidationMessages]="displayValidationMessages">
        </app-passenger-detail-resident>

        <app-frequent-flyer #frequentFlyerInfo *ngIf="notInfant" [displayValidationMessages]="displayValidationMessages">
        </app-frequent-flyer>

        <app-passenger-detail-chubb #insuranceInfo *ngIf="hasInsurance && notInfant && notChild && mainPax && showInsurance" [displayValidationMessages]="displayValidationMessages" [insuranceFormShow]="insuranceFormShow">
        </app-passenger-detail-chubb>

        <!-- <app-passenger-detail-contacts #contactInfo *ngIf="notInfant" [displayValidationMessages]="displayValidationMessages"></app-passenger-detail-contacts> -->

        <app-passenger-detail-work #workInfo *ngIf="notInfant && notChild">
        </app-passenger-detail-work>

        <button aria-label="Save passenger data and close this dialog" *ngIf="showSave" class="button full-width sm-mb-10" (click)="saveSidebar()" [disabled]="saving || triggerCreatePassenger || triggerCreateContact">
			{{'bookingDetails.button.savePaxData' | ibeadmin:'sync'}}
		</button>

    </div>
</div>
